import Agriculture from "../../../assets/images/icons/controlRisksIncidents/sectors/Agriculture.svg";
import Aviation from "../../../assets/images/icons/controlRisksIncidents/sectors/Aviation.svg";
import Construction from "../../../assets/images/icons/controlRisksIncidents/sectors/Construction.svg";
import Education from "../../../assets/images/icons/controlRisksIncidents/sectors/Education.svg";
import Entertainment from "../../../assets/images/icons/controlRisksIncidents/sectors/Entertainment.svg";
import Financial from "../../../assets/images/icons/controlRisksIncidents/sectors/Financial.svg";
import Government from "../../../assets/images/icons/controlRisksIncidents/sectors/Government.svg";
import Healthcare from "../../../assets/images/icons/controlRisksIncidents/sectors/Healthcare.svg";
import Hospitality from "../../../assets/images/icons/controlRisksIncidents/sectors/Hospitality.svg";
import InternationalInstitutions from "../../../assets/images/icons/controlRisksIncidents/sectors/InternationalInstitutions.svg";
import LawEnforcement from "../../../assets/images/icons/controlRisksIncidents/sectors/LawEnforcement.svg";
import Manufacturing from "../../../assets/images/icons/controlRisksIncidents/sectors/Manufacturing.svg";
import Marine from "../../../assets/images/icons/controlRisksIncidents/sectors/Marine.svg";
import Media from "../../../assets/images/icons/controlRisksIncidents/sectors/Media.svg";
import Military from "../../../assets/images/icons/controlRisksIncidents/sectors/Military.svg";
import Mining from "../../../assets/images/icons/controlRisksIncidents/sectors/Mining.svg";
import NGO from "../../../assets/images/icons/controlRisksIncidents/sectors/NGO.svg";
import OilAndGas from "../../../assets/images/icons/controlRisksIncidents/sectors/OilAndGas.svg";
import Pharma from "../../../assets/images/icons/controlRisksIncidents/sectors/Pharma.svg";
import Power from "../../../assets/images/icons/controlRisksIncidents/sectors/Power.svg";
import PrivateProperty from "../../../assets/images/icons/controlRisksIncidents/sectors/PrivateProperty.svg";
import PublicPlace from "../../../assets/images/icons/controlRisksIncidents/sectors/PublicPlace.svg";
import Rail from "../../../assets/images/icons/controlRisksIncidents/sectors/Rail.svg";
import Religious from "../../../assets/images/icons/controlRisksIncidents/sectors/Religious.svg";
import Retail from "../../../assets/images/icons/controlRisksIncidents/sectors/Retail.svg";
import Road from "../../../assets/images/icons/controlRisksIncidents/sectors/Road.svg";
import Telecommunications from "../../../assets/images/icons/controlRisksIncidents/sectors/Telecommunications.svg";
import Unknown from "../../../assets/images/icons/controlRisksIncidents/sectors/Unknown.svg";

export default [
  { Id: 1, Name: "Agriculture", Icon: Agriculture },
  { Id: 2, Name: "Aviation", Icon: Aviation },
  { Id: 3, Name: "Construction", Icon: Construction },
  { Id: 4, Name: "Education", Icon: Education },
  { Id: 5, Name: "Entertainment", Icon: Entertainment },
  { Id: 6, Name: "Financial", Icon: Financial },
  { Id: 7, Name: "Government", Icon: Government },
  { Id: 8, Name: "Hospitality", Icon: Hospitality },
  { Id: 9, Name: "Healthcare", Icon: Healthcare },
  {
    Id: 10,
    Name: "International institutions",
    Icon: InternationalInstitutions,
  },
  { Id: 11, Name: "Law enforcement / Legal", Icon: LawEnforcement },
  { Id: 12, Name: "Marine", Icon: Marine },
  { Id: 13, Name: "Media", Icon: Media },
  { Id: 14, Name: "Military", Icon: Military },
  { Id: 15, Name: "Mining", Icon: Mining },
  {
    Id: 16,
    Name: "NGO's",
    Icon: NGO,
  },
  { Id: 17, Name: "Oil and Gas", Icon: OilAndGas },
  { Id: 18, Name: "Pharmaceuticals", Icon: Pharma },
  { Id: 19, Name: "Power", Icon: Power },
  { Id: 20, Name: "Private Property", Icon: PrivateProperty },
  { Id: 21, Name: "Public spaces", Icon: PublicPlace },
  { Id: 22, Name: "Rail", Icon: Rail },
  { Id: 23, Name: "Religious", Icon: Religious },
  { Id: 24, Name: "Retail", Icon: Retail },
  { Id: 25, Name: "Road", Icon: Road },
  { Id: 26, Name: "Telecommunications", Icon: Telecommunications },
  { Id: 27, Name: "Manufacturing", Icon: Manufacturing },
  { Id: 28, Name: "Unknown", Icon: Unknown },
];
